/* @flow */
/* eslint-env es6,browser */

import _idpbase from './idpbase';
import { loadJSWithTimeout, isDNT } from '../utils/browserutil';
import { logDebug, isdebugEnabled } from '../utils/logger';
import { isCCPAOptedOut } from '../utils/ccpautils';
import getCVars from '../utils/gputils';
import { IDP_COOKIE_EXPIRY_DAYS } from './idpconstants';

const IDP_PUBLINK = 'publink';
const SCRIPT_LOAD_TIMEOUT_MSG = 500;

/**
 * siteID is stored as _pid to reuse
 * and we need extra lid for this IDP partner
 * This one doesn't generate any new ID and
 * augments PubCommonID. So, nothing to return here
 */

class _publinkid extends _idpbase {
  _bInited: boolean;

  _lid: string;

  constructor(name: string = '') {
    super(name);
    this._bInited = false;
    this._lid = '';
  }

  updateConfig({
    url = '',
    pid = '',
    expires = IDP_COOKIE_EXPIRY_DAYS,
    lid = ''
  }: _publinkIDPConfig) {
    super.updateConfig({ url, pid, expires });
    if (
      lid.length === 0 ||
      this._bInited ||
      lid === this._lid ||
      isCCPAOptedOut() ||
      isDNT()
    ) {
      return;
    }

    // check if we have valid email hashes
    // get customer's hash values
    const cvars = getCVars();
    const {
      _uh: sha1Email = '',
      _uh4: md5Email = '',
      _uh6: sha256Email = ''
    } = cvars;
    const emailHashes = [md5Email, sha1Email, sha256Email].filter(
      v => v.length !== 0
    );
    // if email hashes are not available, nothing to do here
    if (emailHashes.length === 0) {
      return;
    }
    // continue initializing here.
    this._lid = lid;
    this._bInited = true;
    // inject global var
    // eslint-disable-next-line camelcase
    this._win.cnvr_launcher_options = { lid: this._lid };
    // try to load the script. If it's successful, start the library
    loadJSWithTimeout(this._url, this._doc, true, SCRIPT_LOAD_TIMEOUT_MSG, {
      object: 'conversant'
    })
      .then(() => {
        logDebug('PubLink is loaded!');
        try {
          let opt = {
            siteId: this._pid,
            emailHashes
          };
          if (isdebugEnabled()) {
            opt = {
              ...opt,
              logging: 'debug'
            };
          }
          this._win.conversant.launch('publink', 'start', opt);
        } catch (error) {
          logDebug(`${this._name} Failed to invoke launcher ${error}`);
        }
        return true;
      })
      .catch((/* error */) => {
        // catch and ignore error
        /* logDebug(`Failed to load PubLink ${error}`); */
      });
  }
}

export default new _publinkid(IDP_PUBLINK);
